<script>
export const group = 'Bottom'
export const reuseComponent = true
</script>

<script setup>
import { onMounted, ref } from 'vue'
import { colors } from '../../../tailwindTheme.config.js'
import ContentBar from './shared/ContentBar.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const colorScheme = { backgroundColor: colors.q.cr.red.primary, color: colors.q.cr.red.darker }

const timelineContentBar = ref(null)
const timelineContentBarOut = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Headline' }).add(timelineContentBar)
})

const { onDisappear } = useDisappearable()
onDisappear(() => gsapTimeline({ name: 'Headline - End' }).add(timelineContentBarOut.value()))
</script>

<template>
  <ContentBar
    :superTitle="item.properties.superTitle"
    :title="item.properties.title"
    :image="item.properties.image"
    :colorScheme="colorScheme"
    @timeline="timelineContentBar = $event"
    @timelineOut="timelineContentBarOut = $event"
  />
</template>
